var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"q10__jumbotron"},[_c('image-with-descriptions',{staticClass:"mb-8 -mt-48",attrs:{"options":{
                image:
                    'pages/' +
                    _vm.currentPage.slug +
                    '/' +
                    _vm.currentPage.images.oImage1.src,
                descriptions: [
                    {
                        text: _vm.currentPage.images.oImage1.edf,
                        position: 'bottom-right', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    } ],
            }}})],1),_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 mb-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                    from: 'from-selective_green',
                    to: 'to-golden_sand',
                }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleTitle.alt)}})]),_c('p',{staticClass:"font-bold text-tundora text-xl mb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleDescription.text)}}),_c('div',{staticClass:"relative mb-8"},[_c('div',{staticClass:"relative pt-6"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                'Continuité piscicole – Emission RCF avril 2021'
                            ),
                        }}})],1),_c('TitleParagraph',{attrs:{"options":{
                        from: 'from-selective_green',
                        to: 'to-golden_sand',
                    }}},[_c('p',{staticClass:"text-lg lg:text-xl 2xl:text-3xl font-bold",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sSubTitleOne_Title.text)}})]),_c('p',{staticClass:"font-bold text-tundora 2xl:text-lg",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sSubTitleOne_Content.text)}})],1),_c('div',{staticClass:"container-components mb-4 lg:mb-8"},[_c('image-with-descriptions',{staticClass:"eliminate-margin",attrs:{"options":{
                        image:
                            'pages/' +
                            _vm.currentPage.slug +
                            '/' +
                            _vm.currentPage.images.oImage2.src,
                        descriptions: [
                            {
                                text: _vm.currentPage.images.oImage2.alt,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                            {
                                text: _vm.currentPage.images.oImage2.text,
                                position: 'top-left', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            } ],
                    }}}),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphOne_Title.text
                            )}}),_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'top',
                            }}})],1),_c('p',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphOne_Content.text
                        )}})],1),_c('div',{staticClass:"card relative"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphTwo_Title.text
                            )}}),_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'right',
                            }}})],1),_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphTwo_Content.text
                        )}}),_c('image-with-descriptions',{staticClass:"mt-2 mb-4",attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage3.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage3.edf_alt,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: _vm.currentPage.images.oImage3.edf,
                                    position: 'top-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}}),_c('image-with-descriptions',{staticClass:"mb-4",attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage4.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage4.edf_alt,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: _vm.currentPage.images.oImage4.edf,
                                    position: 'top-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1),_c('div',{staticClass:"card"},[_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphThree_Content.text
                        )}}),_c('div',[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                    icon: 'diaporama',
                                    collection: _vm.getRichmediaByCollection(
                                        _vm.currentPage,
                                        "Le nouveau Poutès"
                                    ),
                                }}}),_c('hotspot-richmedia',{staticClass:"top-16 right-2",attrs:{"options":{
                                    icon: 'diaporama',
                                    collection: _vm.getRichmediaByCollection(
                                        _vm.currentPage,
                                        "Reconfiguration du barrage de Poutès (2019-2021)"
                                    ),
                                }}})],1),_c('image-with-descriptions',{staticClass:"mt-2",attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage5.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage5.alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: _vm.currentPage.images.oImage5.text,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)])],1),_c('div',{staticClass:"mb-4 lg:mb-8"},[_c('TitleParagraph',{attrs:{"options":{
                        from: 'from-selective_green',
                        to: 'to-golden_sand',
                    }}},[_c('p',{staticClass:"text-lg lg:text-xl 2xl:text-3xl font-bold",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sSubTitleTwo_Title.text)}})]),_c('p',{staticClass:"font-bold text-tundora 2xl:text-lg",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sSubTitleTwo_Content.text)}})],1),_c('div',{staticClass:"container-components mb-4 lg:mb-8"},[_c('div',{staticClass:"card",staticStyle:{"padding-top":"0"}},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'bottom',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFour_Title
                                    .text
                            )}})],1),_c('p',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphFour_Content.text
                        )}})],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFive_Title
                                    .text
                            )}})]),_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphFive_Content.text
                        )}})],1)]),_c('div',{staticClass:"relative"},[_c('image-with-descriptions',{attrs:{"options":{
                        image:
                            'pages/' +
                            _vm.currentPage.slug +
                            '/' +
                            _vm.currentPage.images.oImage6.src,
                        descriptions: [
                            {
                                text: _vm.currentPage.images.oImage6.alt,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                            {
                                text: _vm.currentPage.images.oImage6.text,
                                position: 'top-left', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            } ],
                    }}}),_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                        icon: 'diaporama',
                        collection: _vm.getRichmediaByCollection(
                            _vm.currentPage,
                            'Nessie, le “robot piscine” pour draguer les retenues'
                        ),
                    }}})],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }